export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";